module.exports = __webpack_public_path__ + "assets/filter-scoober-delivery-d89389.svg";